import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarModule } from 'primeng/avatar';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { InputSwitchModule } from 'primeng/inputswitch';

const CommonModulesList: any[] = [
  SplitterModule,
  DialogModule,
  DragDropModule,
  NgSelectModule,
  CKEditorModule,
  CheckboxModule,
  AutoCompleteModule,
  MultiSelectModule,
  OrderListModule,
  TooltipModule,
  OverlayPanelModule,
  RadioButtonModule,
  CalendarModule,
  TableModule,
  AccordionModule,
  NgxPermissionsModule,
  CarouselModule,
  ChipModule,
  ChipsModule,
  AvatarModule,
  ConfirmPopupModule,
  InputSwitchModule,
];

@NgModule({
  declarations: [],
  imports: [...CommonModulesList],
  exports: [...CommonModulesList],
})
export class ListingPrimeNgModule {}
